import { withKeys as _withKeys, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0 mb-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "card card-body mb-0" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "form-group me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_6 = { class: "col p-0" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "form-group me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_10 = { class: "col p-0" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = { class: "form-group me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_14 = { class: "col p-0" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "form-group col" }
const _hoisted_17 = { class: "col-auto p-0 text-end" }
const _hoisted_18 = { class: "row m-4 mt-0" }
const _hoisted_19 = { class: "col-sm-12" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-sm-12" }
const _hoisted_22 = { class: "card card-body" }
const _hoisted_23 = { class: "overflow-auto" }
const _hoisted_24 = { class: "table table-bordered align-middle text-left text-nowrap position-relative" }
const _hoisted_25 = { class: "bg-light" }
const _hoisted_26 = {
  rowspan: "2",
  class: "text-capitalize-first"
}
const _hoisted_27 = {
  rowspan: "2",
  class: "text-capitalize-first"
}
const _hoisted_28 = {
  rowspan: "2",
  class: "text-capitalize-first"
}
const _hoisted_29 = {
  colspan: "4",
  class: "text-capitalize-first text-center"
}
const _hoisted_30 = {
  colspan: "4",
  class: "text-capitalize-first text-center"
}
const _hoisted_31 = { class: "bg-light" }
const _hoisted_32 = { class: "text-capitalize-first еучу" }
const _hoisted_33 = { class: "text-capitalize-first" }
const _hoisted_34 = { class: "text-capitalize-first" }
const _hoisted_35 = { class: "text-capitalize-first" }
const _hoisted_36 = { class: "text-capitalize-first" }
const _hoisted_37 = { class: "text-capitalize-first" }
const _hoisted_38 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_39 = { class: "d-flex flex-column" }
const _hoisted_40 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_41 = {
  key: 0,
  class: "ms-1"
}
const _hoisted_42 = {
  key: 0,
  class: "fa fa-circle-pause text-warning"
}
const _hoisted_43 = {
  key: 1,
  class: "fa fa-circle-play text-success"
}
const _hoisted_44 = {
  key: 0,
  class: "fa fa-circle-pause text-warning"
}
const _hoisted_45 = {
  key: 1,
  class: "fa fa-circle-play text-success"
}
const _hoisted_46 = { class: "text-end" }
const _hoisted_47 = ["onClick", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_UserNameLabel = _resolveComponent("UserNameLabel")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_MerchantStoreForm = _resolveComponent("MerchantStoreForm")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_SettingsHistoryModal = _resolveComponent("SettingsHistoryModal")!
  const _component_CrossBorderRatesModal = _resolveComponent("CrossBorderRatesModal")!
  const _component_ReferralStoreFeesModal = _resolveComponent("ReferralStoreFeesModal")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      min: "1",
                      class: "form-control form-control-sm no-spinner",
                      onKeydown: _cache[0] || (_cache[0] = _withKeys(() => _ctx.applyFilters(), ["enter"])),
                      placeholder: _ctx.helper.trans('labels.store_id'),
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.storeId) = $event))
                    }, null, 40, _hoisted_8), [
                      [_vModelText, _ctx.storeId]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control form-control-sm",
                      onKeydown: _cache[2] || (_cache[2] = _withKeys(() => _ctx.applyFilters(), ["enter"])),
                      placeholder: _ctx.helper.trans('labels.name'),
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestDTO.query) = $event))
                    }, null, 40, _hoisted_12), [
                      [_vModelText, _ctx.requestDTO.query]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_Multiselect, {
                      class: "multiselect-sm",
                      modelValue: _ctx.selectedTrafficGroups,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedTrafficGroups) = $event)),
                      options: _ctx.trafficGroupsOptions,
                      "custom-label": (opt) => `${opt.name} - ${opt.type}`,
                      "track-by": "id",
                      "select-label": "Select",
                      placeholder: _ctx.helper.trans('labels.traffic_group'),
                      "open-direction": "bottom",
                      multiple: true,
                      searchable: true,
                      "internal-search": true,
                      "clear-on-select": false,
                      "close-on-select": false,
                      "options-limit": 100,
                      limit: 1000,
                      "show-no-results": false,
                      "hide-selected": true
                    }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(() => _ctx.applyFilters(), ["prevent"])),
                    class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                  }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[6] || (_cache[6] = _withModifiers(() => _ctx.clearFilters(), ["prevent"])),
                    class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                  }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("table", _hoisted_24, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_25, [
                        _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.helper.trans('labels.id')), 1),
                        _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.helper.trans('labels.title')), 1),
                        _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.helper.trans('labels.merchant')), 1),
                        _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.helper.trans('direction.in')), 1),
                        _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.helper.trans('direction.out')), 1),
                        _cache[12] || (_cache[12] = _createElementVNode("th", {
                          rowspan: "2",
                          class: "text-end",
                          style: {"width":"0px"}
                        }, null, -1))
                      ]),
                      _createElementVNode("tr", _hoisted_31, [
                        _cache[13] || (_cache[13] = _createElementVNode("th", {
                          class: "text-capitalize-first",
                          style: {"width":"0px"}
                        }, null, -1)),
                        _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.helper.trans('labels.traffic_group')), 1),
                        _createElementVNode("th", _hoisted_33, _toDisplayString(_ctx.helper.trans('labels.fee')), 1),
                        _createElementVNode("th", _hoisted_34, _toDisplayString(_ctx.helper.trans('labels.referral_fee')), 1),
                        _cache[14] || (_cache[14] = _createElementVNode("th", {
                          class: "text-capitalize-first",
                          style: {"width":"0px"}
                        }, null, -1)),
                        _createElementVNode("th", _hoisted_35, _toDisplayString(_ctx.helper.trans('labels.traffic_group')), 1),
                        _createElementVNode("th", _hoisted_36, _toDisplayString(_ctx.helper.trans('labels.fee')), 1),
                        _createElementVNode("th", _hoisted_37, _toDisplayString(_ctx.helper.trans('labels.referral_fee')), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response.items, (item) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.id,
                          class: ""
                        }, [
                          _createElementVNode("td", null, _toDisplayString(item.id), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", null, _toDisplayString(item.name), 1),
                            (!item.isActive)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_38, [
                                  _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fa fa-warning" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.store_not_active')), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_39, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.payInRequestLimits, (limit, option) => {
                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                  (limit < 1)
                                    ? (_openBlock(), _createElementBlock("small", _hoisted_40, [
                                        _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fa fa-warning" }, null, -1)),
                                        (option !== 'any')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.helper.trans(`payment_options.${option}`)) + ": ", 1))
                                          : _createCommentVNode("", true),
                                        _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.payInRequestLimitPercentWarning', {percent: _ctx.numberFormatter.formatNumber(_ctx.helper.floatToPercent(limit), 0)})), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 256))
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_UserNameLabel, {
                              user: item.merchant
                            }, null, 8, ["user"])
                          ]),
                          _createElementVNode("td", null, [
                            (item.isPayInBlocked)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_42))
                              : (_openBlock(), _createElementBlock("i", _hoisted_43))
                          ]),
                          _createElementVNode("td", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.trafficGroups.filter(gr => gr._trafficGroup?.type === 'in'), (group) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: group.id
                              }, _toDisplayString(group._trafficGroup?.name), 1))
                            }), 128))
                          ]),
                          _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.payInFee * 100, 2)) + "%", 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.merchant.referralPayInFee * 100 + item.merchant.referral2PayInFee * 100 + item.merchant.referral3PayInFee * 100 + item.merchant.referral4PayInFee * 100 + item.merchant.referral5PayInFee * 100, 2)) + "%", 1),
                          _createElementVNode("td", null, [
                            (item.isPayOutBlocked)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_44))
                              : (_openBlock(), _createElementBlock("i", _hoisted_45))
                          ]),
                          _createElementVNode("td", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.trafficGroups.filter(gr => gr._trafficGroup?.type === 'out'), (group) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: group.id
                              }, _toDisplayString(group._trafficGroup?.name), 1))
                            }), 128))
                          ]),
                          _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.payOutFee * 100, 2)) + "%", 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.merchant.referralPayOutFee * 100 + item.merchant.referral2PayOutFee * 100 + item.merchant.referral3PayOutFee * 100 + item.merchant.referral4PayOutFee * 100 + item.merchant.referral5PayOutFee * 100, 2)) + "%", 1),
                          _createElementVNode("td", _hoisted_46, [
                            _withDirectives((_openBlock(), _createElementBlock("button", {
                              type: "button",
                              onClick: ($event: any) => (_ctx.showMerchantStoreEditModal(item)),
                              title: _ctx.helper.trans('button.edit'),
                              class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                            }, _cache[17] || (_cache[17] = [
                              _createElementVNode("i", { class: "fa fa-pencil" }, null, -1)
                            ]), 8, _hoisted_47)), [
                              [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                              ]
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  (_ctx.response.totalCount > _ctx.response.items.length)
                    ? (_openBlock(), _createBlock(_component_b_pagination, {
                        key: 0,
                        modelValue: _ctx.page,
                        "onUpdate:modelValue": [
                          _cache[7] || (_cache[7] = ($event: any) => ((_ctx.page) = $event)),
                          _cache[8] || (_cache[8] = ($event: any) => (_ctx.loadList()))
                        ],
                        "total-rows": _ctx.response.totalCount,
                        "per-page": _ctx.response.limit,
                        limit: 20,
                        "prev-text": "Back",
                        "next-text": "Next",
                        align: "start",
                        "first-number": "",
                        "hide-goto-end-buttons": "",
                        "hide-ellipsis": ""
                      }, null, 8, ["modelValue", "total-rows", "per-page"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_b_modal, {
        "dialog-class": "modal-lg",
        title: _ctx.merchantStoreModalTitle,
        modelValue: _ctx.merchantStoreModal,
        "body-class": "p-0",
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.merchantStoreModal = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_MerchantStoreForm, {
            ref: "merchantForm",
            onOpenSettingsHistory: _ctx.showStoreHistoryFromForm,
            onOpenCrossBorderRates: _ctx.showCrossBorderRates,
            onOpenReferralSettings: _ctx.showReferralFees,
            onSave: _ctx.saveMerchantStore
          }, null, 8, ["onOpenSettingsHistory", "onOpenCrossBorderRates", "onOpenReferralSettings", "onSave"])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.merchantStoreModal = false)),
            class: "btn btn-outline-secondary btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
          _createVNode(_component_LoaderWrapper, {
            ref: "loaderCreateFrom",
            zoom: 0.5
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.saveMerchantStore())),
                class: "btn btn-outline-primary btn-sm text-capitalize-first"
              }, _toDisplayString(_ctx.helper.trans('button.save')), 1)
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      }, 8, ["title", "modelValue"]),
      _createVNode(_component_SettingsHistoryModal, {
        ref: "storeHistoryModal",
        "entity-type": "store"
      }, null, 512),
      _createVNode(_component_CrossBorderRatesModal, {
        ref: "crossBorderRatesModal",
        onApply: _ctx.applyCrossBorderRates
      }, null, 8, ["onApply"]),
      _createVNode(_component_ReferralStoreFeesModal, {
        ref: "referralFeesModal",
        onApply: _ctx.applyReferralFees
      }, null, 8, ["onApply"])
    ]),
    _: 1
  }, 512))
}